import { render, staticRenderFns } from "./WhistleSvg.vue?vue&type=template&id=423662bc&"
import script from "./WhistleSvg.vue?vue&type=script&lang=ts&"
export * from "./WhistleSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports